export default __webpack_public_path__ + "media/12-29.05703038.svg";